/* eslint-disable eqeqeq */
import React from "react";

const HowItWorks = () => {
    const howItWorksCards = [
        { img: "/images/4.svg", title: "Choose The Cryptocurrency Pair", description: "Lorem Ipsum is simply dummy text of the printing industry." },
        { img: "/images/4.svg", title: "Fill The Payment Detail", description: "Lorem Ipsum is simply dummy text of the printing industry." },
        { img: "/images/4.svg", title: "Confirm The Payment and Receive Your Crypto", description: "Lorem Ipsum is simply dummy text of the printing industry." },
    ]

    return <section id="how-it-works" className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-4 lg:mb-16">
                <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-0 lg:mb-6">How It Works</h2>
            </div>

            <div className="flex flex-col justify-center items-center lg:hidden">
                {howItWorksCards.map((card, i) => (
                    <div key={i} className="text-center">
                        <div className="flex justify-center items-center mt-6">
                            <img src={card.img} alt="img1" />
                        </div>
                        <h3 className="text-xl font-semibold mb-3 mt-3">{card.title}</h3>
                        <p className="text-gray-600">
                            {card.description}
                        </p>
                    </div>
                ))}
            </div>

            <div className="justify-between hidden lg:flex">
                {howItWorksCards.map((card, i) => (
                    <div className={`relative ${i == 1 || i == 3 ? 'mt-20' : ''}`} key={i}>
                        <HowItWorksCard img={card.img} title={card.title} description={card.description} />
                        {i != 2 ? (
                            <div
                                className={`${i == 0 ? 'box2 absolute lg:-right-[52%] top-[110px]' : 'box absolute lg:-right-[50%] top-[40px]'}`}
                            ></div>
                        ) : null}
                    </div>
                ))}
            </div>
        </div>
    </section>
};

export default HowItWorks;

const HowItWorksCard = ({ img, title, description }) => {
    return <div
        className="bg-white rounded-[100%] text-center flex flex-col items-center justify-center mx-auto mb-6 relative p-6 h-[310px] w-[310px]"
        style={{ boxShadow: '0px 8px 25px 0px #00000033' }}
    >

        <img src={img} alt="img1" />
        <h3 className="text-xl font-semibold mb-3 mt-3">{title}</h3>
        <p className="text-gray-600">
            {description}
        </p>
    </div>
}
